export const FOLDER_ENDPOINT = "/folders";
